import { useAccountWaiting } from '../hooks/useAccountWaiting';
import { PAS_VIDEO_ACTIV } from '../utils/video-flag';
import { useAuthProviderV2, useRoutesProvider } from '../../../providers/provider-hooks';
import { Button } from '../../../components/ui/button';
import PageWrap from '../../../components/auth/page-wrap';
import { DOCUMENT_LINKS } from '../../../constants/config';

const TeacherMessage = () => {
  const { logout } = useAuthProviderV2();

  return (
    <div className="rounded-2xl bg-light/95 p-4 shadow">
      <div className={'flex h-full w-full flex-col space-y-4 text-justify font-semibold hyphens-auto'}>
        <p>
          Vă mulțumim că v-ați înregistrat în Școala Ecoterrienilor! Suntem încântați să vă avem alături
          și apreciem interesul dumneavoastră.
        </p>
        <p>Contul dumneavoastră este în curs de verificare și va fi confirmat în cel mai scurt timp posibil.</p>
        {/* Pasul 3 al inscrierii, ca punct de acces PERMANENT.

            🔴 Pozitia e ceruta de S1 si nu e cosmetica: aici, imediat dupa randul
            despre verificare, e locul in care omul isi pune intrebarea „si pana
            atunci ce fac?" — iar acesta e raspunsul. La sfarsit, dupa
            «Cu stima, Echipa ECOTIC», la 360 px ar cadea sub cinci paragrafe de
            politete: sub linia de indoire, dupa formula de incheiere, exact unde
            nimeni nu mai deruleaza.

            Sta sub flagul lui: fara flag ruta nu se inregistreaza, deci un buton
            randat ar duce la autentificare prin catch-all-ul din `main.jsx`, adica
            ar arata identic cu o sesiune expirata.

            🔴 2026-09-21: linkul catre pasul intern de video (`VIDEO_INSCRIERE`) a
            devenit buton catre PDF-ul static (`DOCUMENT_LINKS.MECANISM`), deschis
            intr-un tab nou — fara iframe, Android nu randeaza PDF inline. Cardul de
            protocol (`CardProtocol variant="permanent"`) a fost scos de pe aceasta
            pagina odata cu asta. */}
        {PAS_VIDEO_ACTIV && (
          <a
            href={DOCUMENT_LINKS.MECANISM}
            target="_blank"
            rel="noopener"
            className="flex min-h-11 w-full items-center justify-center rounded-md border border-input bg-white px-4 font-semibold text-dark"
          >
            Deschide materialul informativ (PDF)
          </a>
        )}
        <p>
          De îndată ce procesul de confirmare este finalizat, veți primi o notificare pe email și acces
          complet la aplicație.
        </p>
        <p>Vă mulțumim pentru răbdare și înțelegere.</p>
        <p>Cu stima, Echipa ECOTIC</p>
        {/* 🔴 Eticheta spune ce face butonul (owner, 2026-09-19). Inainte scria „Inapoi la
            pagina principala", dar actiunea e `logout()`: omul ajunge pe login, cu sesiunea
            stearsa, nu pe home. Un text care descrie o navigare si face o deconectare e o
            minciuna mica dar costisitoare — cine apasa crezand ca se intoarce isi pierde
            locul. Varianta „scoatem butonul" a fost evaluata si respinsa: fara el, ecranul
            de asteptare n-are nicio iesire (sidebar-ul nu se randeaza pe acest stagiu). */}
        <div className={'flex w-full justify-center'}>
          <Button onClick={() => logout()}>Deconectează-te</Button>
        </div>
      </div>
    </div>
  );
};

const PupilMessage = () => {
  const { logout } = useAuthProviderV2();

  return (
    <div className="rounded-2xl bg-light/95 p-4 shadow">
      <div className={'flex h-full w-full flex-col space-y-4 text-justify font-semibold hyphens-auto'}>
        <p>Bun venit la Școala Ecoterrienilor! Suntem foarte bucuroși că te-ai alăturat nouă!</p>
        <p>Contul tău este în curs de verificare de către profesorul din școala selectată.</p>
        <p>De îndată ce contul tău este confirmat, vei primi un email și vei putea folosi aplicația.</p>
        <p>Mulțumim pentru răbdare! Abia așteptăm să începi aventura cu noi!</p>
        <p>Cu drag, Echipa ECOTIC</p>
        {/* Acelasi text ca pe cardul profesorului, pentru acelasi motiv: butonul delogheaza.
            ⚠️ Cardul asta nu e randat de nicio ruta azi (singura intrare in `AccountWaitingPage`
            paseaza `ROLES.PROFESOR`), dar textul nu are de ce sa difere in ziua in care va fi. */}
        <div className={'flex w-full justify-center'}>
          <Button onClick={() => logout()}>Deconectează-te</Button>
        </div>
      </div>
    </div>
  );
};

interface AccountWaitingPageProps {
  role: string;
}

export default function AccountWaitingPage({ role }: AccountWaitingPageProps) {
  const { ROLES } = useRoutesProvider();
  useAccountWaiting();

  return (
    <PageWrap>
      {/* `pt-14` sub `md` rezerva locul hamburgerului flotant din `AuthenticatedLayout`: cardul
          pleaca de la 24 px (`py-6` din `PageWrap`) si ajunge la 80 = 68 (josul butonului, masurat
          la 360) + 12. AICI, nu in `PageWrap`: acela e comun cu noua pagini publice, fara hamburger. */}
      <div className="z-10 mx-auto flex w-full max-w-lg flex-1 flex-col justify-center pt-14 md:pt-0">
        {ROLES.PROFESOR === role && <TeacherMessage />}
        {ROLES.ELEV === role && <PupilMessage />}
      </div>
    </PageWrap>
  );
}
